import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '/Users/prodanirina/formular-app/src/Components/Register Form/RegisterForm.css';
import { FaUser, FaUserTie, FaPhoneAlt } from 'react-icons/fa';
import { PiBuildingApartmentFill } from 'react-icons/pi';
import { MdEmail } from 'react-icons/md';


const RegisterForm = () => {

    const [formData, setFormData] = useState({
        First_Name: '',
        Last_Name: '',
        Company: '',
        Position: '',
        Email: '',
        Phone_Number: ''
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://script.google.com/macros/s/AKfycbwgqO0Dp8lv9uv79NNFsZ6Yey4bXS4cziSYh5dw-tVa6Lr82u9Y9aDBr9gI33ELQvWtQQ/exec', { 
                method: 'POST',
                mode: 'no-cors', 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams(formData)
            });
            console.log("Form submitted successfully:", response);

            // Redirecționare către pagina de mulțumire
            navigate('/register/thank-you');
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("A apărut o problemă la trimiterea formularului.");
        }
    };

  return (
      <div className='wrapper'> 
        <form onSubmit={handleSubmit} >
        <h1> Register Form</h1>
        <div className="input-box">
            <input type="text" name="First_Name" placeholder='First Name' required value={formData.First_Name} onChange={handleChange} />
            <FaUser className='icon' />
        </div>
        <div className="input-box">
            <input type="text" name="Last_Name" placeholder='Last Name' required value={formData.Last_Name} onChange={handleChange}/>
            <FaUser className='icon'/>
        </div>
        <div className="input-box">
            <input type="text" name="Company" placeholder='Company' required value={formData.Company} onChange={handleChange}/>
            <PiBuildingApartmentFill className='icon'/>
        </div>
        <div className="input-box">
            <input type="text" name="Position" placeholder='Position' required value={formData.Position} onChange={handleChange}/>
            <FaUserTie className='icon'/>
        </div>
        <div className="input-box">
            <input type="email" name="Email" placeholder='email@example.com' required value={formData.Email} onChange={handleChange}/>
            <MdEmail className='icon'/>
        </div>
        <div className="input-box">
            <input type='tel' name="Phone_Number" placeholder='Mobile Phone (Optional)' value={formData.Phone_Number} onChange={handleChange}/>
            <FaPhoneAlt className='icon'/>
        </div>

        <div className="terms-conditions">
            <label><input type="checkbox" required /> I agree with the </label>
            <a href="https://fiaintegra.ro/terms-and-conditions/"> terms and conditions </a> <label> and the </label>
            <a href="https://fiaintegra.ro/privacy-policy/"> privacy policy </a> <label> of </label> 
            <a href= "https://fiaintegra.ro/ "> fiaintegra.ro</a>
        </div>

        <button type="submit">Submit</button>
      </form>

      </div>
  )
}

export default RegisterForm
